<template>
  <qx-card-form title="结算信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 回单期限 -->
      <div slot="recive" slot-scope="prop">
        <div v-show="prop.form.balanceType === '1' || prop.form.balanceType === '2'">
          离场日期+
          <el-input class="inputBox" v-model="otherFormData.reciveTime" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.balanceType === '3'">
          <el-input class="appendInputBox" v-model="otherFormData.reciveMonth" placeholder="请输入">
            <span slot="suffix">个月后
              <el-select
                class="inputAppendSelect"
                v-model="otherFormData.reciveDay"
                :clear="true"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in 31"
                  :key="item"
                  :label="item + '号'"
                  :value="item" />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
      <!-- 回单期限 end -->
      <!-- 收款期限 -->
      <div slot="collection" slot-scope="prop">
        <div v-show="prop.form.balanceType === '2'">
          回单审核后+
          <el-input class="inputBox" v-model="otherFormData.collectionTime" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.balanceType === '3'">
          <el-input class="appendInputBox" v-model="otherFormData.collectionMonth" placeholder="请输入">
            <span slot="suffix">个月后
              <el-select
                class="inputAppendSelect"
                v-model="otherFormData.collectionDay"
                :clear="true"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in 31"
                  :key="item"
                  :label="item + '号'"
                  :value="item" />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
      <!-- 收款期限 end -->
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
} from 'api';
export default {
  data () {
    return {
      tmplData: null,
      otherFormData: {
        reciveTime: '', // 回单期限天数
        reciveMonth: '', // 回单期限第几个月
        reciveDay: '', // 回单期限第几号
        collectionTime: '', // 收款期限天数
        collectionMonth: '', // 收款期限第几个月
        collectionDay: '', // 收款期限第几号
      },
      baseForm: {
        balanceTypeOptions: [],
        form: [
          {
            label: '结算方式',
            value: 'balanceType',
            type: 'select',
            width: '240px',
            onChange: () => {
              this.handleLabelTypeChange();
            },
          },
          {
            label: '回单期限',
            value: 'recive',
            slot: true,
          },
          {
            label: '收款期限',
            value: 'collection',
            slot: true,
            hide: false,
          },
        ],
        rules: {
          balanceType: [ // 结算方式
            { required: true, message: '请选择结算方式', trigger: 'blur' },
          ],
          recive: [ // 回单期限
            { validator: this.checkRecive, trigger: 'submit' },
          ],
          collection: [ // 收款期限
            { validator: this.checkCollection, trigger: 'submit' },
          ],
        },
      },
    };
  },
  methods: {
    getTmpl () {
      return this.tmplData;
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证回单期限
     */
    checkRecive (rule, value, call) {
      const balanceType = this.$refs.baseForm.getVal('balanceType');
      if ((balanceType === '1' || balanceType === '2') && !this.otherFormData.reciveTime) {
        call('请输入回单期限天数');
      } else if (balanceType === '3' && (!this.otherFormData.reciveMonth || !this.otherFormData.reciveDay)) {
        call('请输入回单期限天数');
      } else {
        call();
      }
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证收款期限
     */
    checkCollection (rule, value, call) {
      const balanceType = this.$refs.baseForm.getVal('balanceType');
      if (balanceType === '2' && !this.otherFormData.collectionTime) {
        call('请输入收款期限天数');
      } else if (balanceType === '3' && (!this.otherFormData.collectionMonth || !this.otherFormData.collectionDay)) {
        call('请输入收款期限天数');
      } else {
        call();
      }
    },

    async getList () {
      const enumsData = await getEnumList({
        codeType: 'BALANCE_TYPE',
      });
      this.baseForm.balanceTypeOptions = enumsData[0];
    },
    async handleLabelTypeChange () {
      const balanceType = await this.$refs.baseForm.getVal('balanceType');
      let isNotAuto = balanceType === '1';
      const tar = ['collection'];
      // 预付全款情况下隐藏收款期限
      this.baseForm.form.forEach((item) => {
        if (tar.indexOf(item.value) !== -1) {
          item.hide = isNotAuto;
        }
      });
    },
    async cacheData () {
      let res = await this.$refs.baseForm.getVal();
      res = {
        balanceType: res.balanceType,
        payWay: res.balanceType,
        ...this.otherFormData,
      };
      res.tmplData = this.tmplData;
      return res;
    },

    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData = {
          balanceType: formData.balanceType,
          payWay: formData.balanceType,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async init (data = {}) {
      const res = {
        balanceType: data.payWay ? data.payWay : this.baseForm.balanceTypeOptions[0].value,
      };
      this.$refs.baseForm.setVal(res);
      this.setFormVal(this.otherFormData, data);
      await this.handleLabelTypeChange();
      if (data.tmplData) {
        this.tmplData = data.tmplData;
      } else {
        this.tmplData = await this.$refs.baseForm.getVal();
        this.tmplData = {
          balanceType: this.tmplData.balanceType,
          payWay: this.tmplData.balanceType,
          ...this.otherFormData,
        };
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
